module.exports = "//public.zight.com/packs/media/images/loader-27b2e96a82c7718eee095d4afeb63f09.svg";